module.exports = __webpack_public_path__ + "img/chat-search-no-message.12fcffd6.png";